import { updateWalletDataAction } from '@/redux/slices/wallet'
import store from '@/redux/store'
import { collection, getDocs } from 'firebase/firestore'
import { firebaseDB } from '@/config/init'

export const checkCurrencyfromAPI = async () => {
  // API shut down - no-op
}

export const getWallets = async (accessToken, userId) => {
  try {
    const walletsRef = collection(firebaseDB, 'keyStore', userId, 'wallets')
    const snapshot = await getDocs(walletsRef)

    if (snapshot.empty) {
      return
    }

    const wallets = snapshot.docs.map((doc, index) => ({
      walletID: doc.id,
      walletTitle: doc.data().walletTitle || (index === 0 ? 'Default Wallet' : `Wallet ${index + 1}`),
    }))

    store.dispatch(updateWalletDataAction(wallets))
  } catch (err) {
    console.error('Failed to load wallets from Firestore:', err)
  }
}

export const refreshWallets = async (userId) => {
  if (userId) {
    await getWallets(null, userId)
  }
}
